'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _functional = require('../../utils/functional');

var _drawer = require('./drawer');

var _drawer2 = _interopRequireDefault(_drawer);

var _helpers = require('../_helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var matches = {
  trigger: '[data-module-drawers-trigger]',
  close: '[data-module-drawers-close]',
  backdrop: '.js-Drawers_Backdrop'
};
var els = {
  body: document.body || document.documentElement,
  backdrop: (0, _functional.getElement)(matches.backdrop),
  drawers: (0, _functional.getElement)('.drw-Drawers')
};
var classes = {
  activeClass: 'drw-Drawers-active',
  activeDrawerClass: 'drw-Drawer-active',
  siteOverflowed: 'util-SiteOverflowed'
};
var options = {
  openOneAtATime: true
};

var Drawers = {
  init: function init() {
    var _this = this;

    var keys = (0, _functional.getElements)('[data-module-drawers-trigger]').map(function (el) {
      return el.dataset.moduleDrawersTrigger;
    });
    var drawers = keys.map(function (key) {
      return _this.createDrawer(key);
    });

    this.keys = keys;
    this.drawers = drawers;
    this.listeners = (0, _create2.default)(_helpers.Listeners);

    this.handleClick = this.handleClick.bind(this);

    this.setupListeners();
  },

  createDrawer: function createDrawer(key) {
    var drawer = (0, _create2.default)(_drawer2.default);
    drawer.init({ key: key });

    return drawer;
  },

  setupListeners: function setupListeners() {
    this.listeners.add(els.body, 'click', this.handleClick);
  },

  handleClick: function handleClick(event) {
    var target = event.target;

    var isTrigger = target.closest(matches.trigger) !== null;
    var isClose = target.closest(matches.close) !== null;
    var isBackdrop = target.closest(matches.backdrop) !== null;
    var shouldReturnEarly = isTrigger === false && isClose === false && isBackdrop === false;

    if (shouldReturnEarly) return;

    event.preventDefault();

    if (isTrigger) {
      var trigger = target.closest(matches.trigger);
      var key = trigger.dataset.moduleDrawersTrigger;

      if (this.keys.includes(key)) {
        this.activeDrawerKey = key === this.activeDrawerKey ? '' : key;
      } else {
        this.drawers.push(this.createDrawer(key));
      }
    }

    if (isClose || isBackdrop) {
      this.activeDrawerKey = '';
    }
  },

  get activeDrawerKey() {
    return this._activeDrawerKey;
  },
  set activeDrawerKey(v) {
    var _this2 = this;

    els.body.classList.remove('drw-Drawers-' + this._activeDrawerKey);
    if (v !== '') {
      els.body.classList.add('drw-Drawers-' + v);
    }

    this._activeDrawerKey = v;

    if (v === '') {
      this.drawers.forEach(function (d) {
        return d.isOpen = false;
      });
    } else {
      var drawer = this.drawers.find(function (d) {
        return d.key === _this2._activeDrawerKey;
      });
      drawer.isOpen = true;

      if (options.openOneAtATime) {
        this.drawers.filter(function (d) {
          return d.key !== _this2._activeDrawerKey;
        }).forEach(function (d) {
          return d.isOpen = false;
        });
      }
    }

    var allDrawersAreClosed = this.drawers.every(function (d) {
      return d.isOpen === false;
    });
    els.drawers.classList.toggle(classes.activeClass, !allDrawersAreClosed);
    els.body.classList.toggle(classes.siteOverflowed, !allDrawersAreClosed);

    if (window.location.href.indexOf('cart') > -1) {
      els.drawers.classList.toggle(classes.activeClass, false);
      els.body.classList.toggle(classes.siteOverflowed, false);
    }
  }
};

exports.default = Drawers;